import { MetaData } from '@dehaat/kisan-app-bl/models/Feed';
import Image from 'next/image';
import { ComboType } from '@/models/Combo';
import ComboCard from './ComboCard';
import ViewAllButton from './ViewAllButton';
export interface ISection<T> {
  id: number;
  data: T;
  metadata: MetaData;
  view_type: string;
}
interface Props {
  metaData: ISection<ComboType[]>;
}
const ComboGrid = ({
  metaData
}: Props) => {
  const bannerImage = metaData.metadata.banner_image;
  const combos: ComboType[] = metaData?.data || [];
  const displayCombos = combos.slice(0, 8); // same as product grid

  const getBannerImage = () => {
    if (typeof bannerImage === 'object' && bannerImage !== null) {
      if (window.innerWidth <= 480 && bannerImage?.mobile_image) return bannerImage?.mobile_image || '';
      if (window.innerWidth <= 768 && bannerImage?.desktop_image) return bannerImage?.desktop_image || '';
      return bannerImage?.tablet_image || '';
    } else {
      bannerImage;
    }
  };
  const bannerSrc = getBannerImage();
  return <section className="lg:rounded-xl" style={{
    background: metaData.metadata.secondary_bg || 'white'
  }} data-sentry-component="ComboGrid" data-sentry-source-file="ComboGrid.tsx">
      {bannerSrc && <div className="relative rounded-t-xl w-full h-[100px] md:h-[150px] lg:h-[180px] overflow-hidden">
          <Image src={bannerSrc} alt="combo-banner" fill className="object-cover" />
        </div>}
      <div className="gap-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 px-4 py-4">
        {displayCombos.map(combo => <ComboCard key={combo.id} combo={combo} />)}
      </div>
      <div className="px-4 pb-6">
        <ViewAllButton deepLink={metaData.metadata.deep_link} bgColor="white" componentName={metaData.metadata.title} componentId={metaData.id} data-sentry-element="ViewAllButton" data-sentry-source-file="ComboGrid.tsx" />
      </div>
    </section>;
};
export default ComboGrid;